import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import { MessageItem } from 'store';

@Component({
	mounted() {
		if (this.$props.message.expires) {
			window.setTimeout(() => {
				this.$emit('message:remove', this.$props.message.id);
			}, this.$props.message.expires);
		}
	},

	beforeDestroy() {
		if (this.closeTimeoutId) {
			window.clearTimeout(this.closeTimeoutId);
		}
	}
})
export default class FlashMessages extends Vue {
	@Prop({
		default() {
			return {};
		}
	})
	message!: MessageItem;

	closeTimeoutId: number | null = null;

	@Emit('message:remove')
	handleCloseBtnClick(): string {
		return this.$props.message.id;
	}
}
